import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import { SoilCore } from '../../../db';
import CoresList from '../../cores/CoresList';
import { ManualMeasurementDialogParameters } from '../../../services/ManualMeasurementsChecker';
import { Divider, Grid } from '@mui/material';

type Props = {
  cores: SoilCore[];
  openManualMeasurementDialog: (params: ManualMeasurementDialogParameters) => void;
  handleClose: () => void;
};

export default function CoresDialog({ cores, handleClose, openManualMeasurementDialog }: Props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [pulledOnly, setPulledOnly] = useState(false);

  const filteredCores = cores.filter((core) => {
    if (!pulledOnly) {
      return true;
    }

    return core.pulled;
  });

  return (
    <Dialog fullScreen={fullScreen} fullWidth open onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle id="responsive-dialog-title">Cores List</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={2} size={12}>
          <Grid container direction="row" alignItems="center" spacing={2} size={12}>
            <Grid>Filters: </Grid>

            <Grid>
              <ToggleButton
                size="small"
                value="check"
                selected={pulledOnly}
                onChange={() => {
                  setPulledOnly(!pulledOnly);
                }}
              >
                Pulled Only
              </ToggleButton>
            </Grid>
          </Grid>

          <Divider />

          <Grid>
            <CoresList cores={filteredCores} openManualMeasurementDialog={openManualMeasurementDialog} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Dismiss
        </Button>
      </DialogActions>
    </Dialog>
  );
}
